module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS7.1d14426a.jpg";